const UserIndex = () => import("@/views/user/UserIndex.vue")
const UserTabProfile = () => import("@/views/user/tabs/UserTabProfile.vue")
const UserTabWallet = () => import("@/views/user/tabs/UserTabWallet.vue")
const UserTabCarpool = () => import("@/views/user/tabs/UserTabCarpool.vue")

export default [
    {
        path: "/admin/users-v2/:userUuid?",
        name: "userIndex",
        component: UserIndex,
        meta: {
            label: "User"
        },
        children: [
            {
                path: "profile",
                name: "userProfile",
                component: UserTabProfile
            },
            {
                path: "wallet",
                name: "userWallet",
                component: UserTabWallet
            },
            {
                path: "carpool",
                name: "userCarpool",
                component: UserTabCarpool
            }
        ]
    }
]
